import { Layout } from "./components/Layout";
import { CoffeeCalculator } from "./components/CoffeeCalculator";

function App() {
  return (
    <Layout>
      <CoffeeCalculator />
    </Layout>
  );
}

export default App;
